import React, { FC, PropsWithChildren } from 'react'

export const SvgWrapper: FC<{ size?: number } & PropsWithChildren> = ({
  children,
  size,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
  >
    {children}
  </svg>
)
